import "./index";
import "../../../public/adminarea/assets/vendors/js/jquery.flexdatalist.min.js";
import "./sakis";
import "./js/tooltip-new";
import "./js/jquery.remove-upcase-accents"
import htmx from 'htmx.org';
// import "./js/htmx";
// import "./js/response-targets";
// console.log("Hello webpack!")
import Alpine from 'alpinejs'

window.htmx = htmx;
window.Alpine = Alpine

Alpine.start()
